module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/129-ossetia-135b82c321b1024cf2ec6138f6d843bb.svg";